import { Grid, Text } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface FormColumn extends PropsWithChildren {
  label?: string;
  span?: [number, number];
}

export const FormColumn = (props: FormColumn) => {
  const { label, children, span } = props;

  return (
    <>
      <Grid.Col span={span ? span[0] : 5}>
        <Text>{label}</Text>
      </Grid.Col>
      <Grid.Col span={span ? span[1] : 7}>{children}</Grid.Col>
    </>
  );
};
